import { ImprintPageLayout } from "../pagelayouts/imprint";
import { useMarketingPagesTracking } from "../hooks/marketingPagesTracking";
import { GoogleTagManagerScript } from "../tracking/GoogleTagManager/GoogleTagManagerScript";

const ImprintPage = () => {
    useMarketingPagesTracking();

    return (
        <>
            <GoogleTagManagerScript />
            <ImprintPageLayout />
        </>
    );
};

export async function getStaticProps() {
    return {
        props: {}
    };
}

export default ImprintPage;
